import { T } from "../../../styles/Theme";

export const InternetIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.222 4.444a.889.889 0 0 0-1.778 0V16.89H3.43a3.37 3.37 0 0 0-2.425 1.041A3.623 3.623 0 0 0 0 20.444V24c0 .943.361 1.847 1.004 2.514a3.368 3.368 0 0 0 2.425 1.041H28.57a3.37 3.37 0 0 0 2.425-1.04A3.623 3.623 0 0 0 32 24v-3.556c0-.943-.361-1.847-1.004-2.514a3.368 3.368 0 0 0-2.425-1.041H6.222V4.444ZM3.43 18.667h25.14c.417 0 .83.17 1.145.497.317.33.506.788.506 1.28V24c0 .492-.189.951-.506 1.28a1.59 1.59 0 0 1-1.145.498H3.43a1.59 1.59 0 0 1-1.145-.498A1.846 1.846 0 0 1 1.778 24v-3.556c0-.491.189-.95.506-1.28a1.59 1.59 0 0 1 1.145-.497Z"
        fill={T.blue}
      />
      <path
        d="M17.134 11.046a.889.889 0 0 1 .15-1.248 8.009 8.009 0 0 1 5.101-1.705 8.035 8.035 0 0 1 4.77 1.703.889.889 0 0 1-1.099 1.399A6.258 6.258 0 0 0 22.35 9.87a6.23 6.23 0 0 0-3.966 1.325.89.89 0 0 1-1.249-.15Zm2.639 1.943a.889.889 0 0 0 1.09 1.403c.37-.287.831-.438 1.298-.426.436.011.867.168 1.209.439a.889.889 0 1 0 1.104-1.393 3.825 3.825 0 0 0-2.267-.823 3.815 3.815 0 0 0-2.434.8Zm-5.34-5.283a.889.889 0 0 1 .103-1.253 11.961 11.961 0 0 1 7.832-2.84c2.74.022 5.41.994 7.521 2.739a.889.889 0 0 1-1.132 1.37 10.212 10.212 0 0 0-6.403-2.331c-2.44-.02-4.808.839-6.668 2.418a.889.889 0 0 1-1.253-.103Z"
        fill={T.blue}
      />
    </svg>
  );
};
